import type { Configuration } from '@azure/msal-browser';

/**
 * Anmeldung ueber Entra ID.
 *
 * Die Kennung gehoert zu einer eigenen Registrierung fuer die Weboberflaeche -
 * nicht zu der des Add-ins und nicht zu der der API. Jede Anwendung, die ein
 * Token anfordert, braucht ihre eigene; eine gemeinsame liesse sich nicht
 * getrennt entziehen.
 */
// Fehlt eine Angabe, scheitert die Anmeldung mit einer Meldung von Entra, die
// den Grund nicht nennt. Ein Abbruch beim Laden ist deutlicher.
for (const [name, wert] of Object.entries({
  VITE_CLIENT_ID: import.meta.env.VITE_CLIENT_ID,
  VITE_TENANT_ID: import.meta.env.VITE_TENANT_ID,
  VITE_API_SCOPE: import.meta.env.VITE_API_SCOPE,
})) {
  if (!wert) {
    throw new Error(
      `${name} ist beim Bauen nicht gesetzt worden. Die Werte werden als ` +
        'Build-Argumente uebergeben - siehe src/Tuv.Export.Web/README.md.',
    );
  }
}

export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_TENANT_ID}`,
    /*
     * Die Rückkehradresse der ANMELDUNG ist die Anwendung.
     *
     * Sie muss es sein: Die Anwendung meldet mit `loginRedirect` an, und
     * `handleRedirectPromise()` in main.tsx verarbeitet die Antwort. Zeigte die
     * Adresse auf eine leere Seite, landete der Browser dort — und niemand
     * verarbeitete die Antwort.
     *
     * Genau das war der zweite Fehler beim ersten Anlauf: Eine leere
     * Rückkehrseite ist richtig für ein Popup- oder ein rein stilles Verfahren.
     * Bei `loginRedirect` bricht sie die Anmeldung.
     */
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    // Im sessionStorage, nicht im localStorage: Beim Schliessen des Browsers
    // endet die Anmeldung. Auf gemeinsam genutzten Rechnern ist das der
    // sicherere Weg, und die erneute Anmeldung kostet einen Klick.
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
};

/** Der Bereich, den die API erwartet. */
export const apiRequest = {
  scopes: [import.meta.env.VITE_API_SCOPE],
};

/**
 * Die Rückkehradresse für die STILLE Erneuerung.
 *
 * --- Warum sie eine andere ist als bei der Anmeldung ------------------------------
 *
 * MSAL erneuert Zugangstoken über ein verstecktes iframe. Zeigt die Adresse dabei
 * auf die Anwendung, lädt MSAL sie vollständig in das iframe — und nginx verweigert
 * das mit `X-Frame-Options: DENY`. Die Erneuerung scheitert, MSAL fällt auf ein
 * Popup zurück, und der Browser sperrt es.
 *
 * Sichtbar wird dann nur `popup_window_error`, was die Ursache nicht nennt.
 *
 * Deshalb bekommt `acquireTokenSilent` eine eigene, leere Seite. Sie darf
 * eingebettet werden — als einzige Adresse der Anwendung —, und sie startet nicht
 * React, um eine Adresszeile auszuwerten.
 *
 * --- Warum nicht überall dieselbe -----------------------------------------------
 *
 * Weil `loginRedirect` das Gegenteil braucht: dort muss die Rückkehrseite MSAL
 * ausführen. Eine leere Seite bricht die Anmeldung, eine volle die stille
 * Erneuerung. Es sind zwei Vorgänge mit entgegengesetzter Anforderung.
 *
 * Beide Adressen müssen in Entra als Umleitungs-URI des SPA eingetragen sein.
 */
export const stilleErneuerung = `${window.location.origin}/anmeldung.html`;
